export const ENDPOINTS = {
  getExperience: '/gateway/admin/experiences/:id',
  getExperiences: '/gateway/admin/experiences',
  createExperience: '/gateway/admin/experiences',
  updateExperience: '/gateway/admin/experiences/:id',
  deleteExperience: '/gateway/admin/experiences/:id',
  publishExperience: '/gateway/admin/experiences/:id/publish',
  unpublishExperience: '/gateway/admin/experiences/:id/unpublish',
} as const;

export const CORE_QUERY_KEYS = {
  experiences: 'admin-experiences',
  experience: 'admin-experience',
} as const;
